/* eslint react/button-has-type: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  AppendedIcon,
  ChildrenWrapper,
  getButtonStyles,
  newButtonDefaults,
  PrependedIcon,
} from './styles';
import LoadingMask from '../LoadingMask';

const Button = ({
  isLoading,
  prependIcon,
  appendIcon,
  appearance,
  padding,
  children,
  isActive,
  ...htmlSafeProps
}) => {
  return (
    <button {...htmlSafeProps}>
      {prependIcon && <PrependedIcon onlyIcon={!children} className={prependIcon} />}

      <ChildrenWrapper className="text">{children}</ChildrenWrapper>

      {appendIcon && !isLoading && <AppendedIcon onlyIcon={!children} className={appendIcon} />}

      {isLoading && <AppendedIcon className="fa fa-circle-notch fa-spin" />}
    </button>
  );
};

Button.defaultProps = {
  children: null,
  type: 'button',
  isLoading: false,
  prependIcon: null,
  appendIcon: null,
  size: 'regular',
  version: 'legacy',
};

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
  prependIcon: PropTypes.string,
  appendIcon: PropTypes.string,
  size: PropTypes.oneOf(['small', 'regular', 'big', 'massive']),
  version: PropTypes.oneOf(['legacy', 'abby']),
};

export default Button;

const StyledButton = styled(Button)`
  ${newButtonDefaults}
  ${getButtonStyles}

  ${ChildrenWrapper} {
    vertical-align: middle;
  }

  ${PrependedIcon},
  ${AppendedIcon} {
    font-size: 1.2em;

    margin-left: ${props => {
      if (!props.children) {
        return 0;
      }
      if (props.isLoading || props.appendIcon) {
        return '.5em';
      }
      return 0;
    }};

    margin-right: ${props => {
      if (!props.children) {
        return 0;
      }
      if (props.prependIcon) {
        return '.5em';
      }
      return 0;
    }};

    vertical-align: middle;
  }
`;

StyledButton.PrependedIcon = PrependedIcon;
StyledButton.AppendedIcon = AppendedIcon;

const PrimaryButton = props => <StyledButton {...props} appearance="primary" />;
StyledButton.Primary = PrimaryButton;

const SecondaryButton = props => <StyledButton {...props} appearance="secondary" />;
StyledButton.Secondary = SecondaryButton;

const DangerButton = props => <StyledButton {...props} appearance="danger" />;
StyledButton.Danger = DangerButton;

const HighlightedLinkButton = props => <StyledButton {...props} appearance="highlightedLink" />;
StyledButton.HighlightedLinkButton = HighlightedLinkButton;

const LinkButton = props => <StyledButton {...props} appearance="link" />;
StyledButton.Link = LinkButton;

export const LoadingLinkButton = () => (
  <LoadingMask style={{ display: 'inline-block' }} isDark width="100px" height="20px" />
);

const ShadowButton = props => <StyledButton {...props} appearance="shadow" />;
StyledButton.Shadow = ShadowButton;

StyledButton.AppendedIcon = AppendedIcon;
StyledButton.PrependedIcon = PrependedIcon;
StyledButton.ChildrenWrapper = ChildrenWrapper;

const ButtonAppendedIcon = AppendedIcon;
const ButtonPrependedIcon = PrependedIcon;

export {
  StyledButton,
  PrimaryButton,
  SecondaryButton,
  DangerButton,
  LinkButton,
  ShadowButton,
  ChildrenWrapper,
  HighlightedLinkButton,
  ButtonAppendedIcon,
  ButtonPrependedIcon,
};
